var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { fade, getContrastRatio } from "@material-ui/core/styles/colorManipulator";
import createMuiMixins from "@material-ui/core/styles/createMixins";
import { shadeMap } from "./colors";
export var createMixins = function (_a) {
    var breakpoints = _a.breakpoints, spacing = _a.spacing, palette = _a.palette, _b = _a.overrides, overrides = _b === void 0 ? {} : _b;
    var shadeOfColor = function (color, shade) {
        if (shade === void 0) { shade = "base"; }
        var shadeValue = shadeMap[shade];
        return palette[color][shadeValue];
    };
    // `${color}:${shade}`: value
    var textColorCache = {};
    var textColorForShadeOfColor = function (color, shade) {
        if (shade === "lightest") {
            return shadeOfColor(color, "darkest");
        }
        var cacheKey = color + ":" + shade;
        if (textColorCache[cacheKey]) {
            return textColorCache[cacheKey];
        }
        var bgColor = shadeOfColor(color, shade);
        var textPrimaryContrastRatio = getContrastRatio(palette.text.primary, bgColor);
        var whiteContrastRatio = getContrastRatio(palette.common.white, bgColor);
        var textColor = whiteContrastRatio >= textPrimaryContrastRatio ? palette.common.white : palette.text.primary;
        textColorCache[cacheKey] = textColor;
        return textColor;
    };
    var focusRing = function (options) {
        if (options === void 0) { options = {}; }
        var _a = options.color, color = _a === void 0 ? palette.primary.main : _a, _b = options.type, type = _b === void 0 ? "default" : _b, _c = options.opacity, opacity = _c === void 0 ? 0.25 : _c;
        var shadow = fade(color, opacity) + " 0px 0px 0px 0.25em";
        return {
            boxShadow: type === "default" ? shadow : "inset " + shadow,
        };
    };
    var borderAsBoxShadow = function (color, width) {
        if (width === void 0) { width = 1; }
        return "inset 0px 0px 0px " + width + "px " + color;
    };
    var appBarAction = function () {
        var hoverStyles = {
            color: palette.common.white,
            backgroundColor: shadeOfColor("neutral", "darker"),
        };
        return {
            root: {
                backgroundColor: "transparent",
            },
            hover: hoverStyles,
            active: hoverStyles,
            focus: __assign({ color: palette.common.white }, focusRing({ color: palette.common.white, opacity: 0.4 })),
        };
    };
    var mixins = __assign({ borderAsBoxShadow: borderAsBoxShadow,
        shadeOfColor: shadeOfColor,
        textColorForShadeOfColor: textColorForShadeOfColor,
        focusRing: focusRing,
        appBarAction: appBarAction }, createMuiMixins(breakpoints, spacing, overrides));
    return mixins;
};
